module.exports = __webpack_public_path__ + "static/media/design_flexibility_bg_icon.d1ea46a2.svg";